import { AccessManager } from '../components/access/AccessManager';
import { accessRequest } from '../services/accessClient';
export default function AdminPage() { return <div className="p-4 sm:p-8"><AccessManager request={accessRequest} serviceScope="administration" /></div>; }
